import {createSlice} from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "payment-store", 
  storage,
  whitelist: ["orderInfo", "paymentSuccessful", "paymentFailed", "creatingPayment"]
}

const initialState = {
  listLoading: false,
  actionsLoading: false,
  creatingPayment: false,
  customerPayment: undefined,
  receiptCreatedNum: "",
  processingOrder: false,
  orderInfo: {},
  callingPaymentEndpoint: false,
  //bspPayPayment: false,
  paymentSuccessful: false,
  paymentFailed: false,
  paymentFailResponse: "",
  pdfReceiptStr: "",
  captchaValidated: false,
  validatingCaptcha: false,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action",
  payment: "payment",
  captcha: "captcha",
  order: "order",
  bsppay: "bsppay"
};
  

const paymentSlice = createSlice({
  name: 'payment',
  initialState:initialState,
  reducers: {
    catchError: (state, action) => {
      state.lastError = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else if (action.payload.callType === callTypes.payment) {
        state.creatingPayment = false;
        state.callingPaymentEndpoint = false;
      } else if (action.payload.callType === callTypes.order) {
        state.processingOrder = false;
        state.callingPaymentEndpoint = false;
      } else if (action.payload.callType === callTypes.bsppay) {
        state.bspPayPayment = false;
      } else if (action.payload.callType === callTypes.captcha) {
        state.validatingCaptcha = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.lastError = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else if (action.payload.callType === callTypes.payment) {
        state.creatingPayment = true;
      } else if (action.payload.callType === callTypes.order) {
        state.processingOrder = true;
        state.callingPaymentEndpoint = true;
      } else if (action.payload.callType === callTypes.bsppay) {
        state.bspPayPayment = true;
      } else if (action.payload.callType === callTypes.captcha) {
        state.validatingCaptcha = true;
      } else {
        state.actionsLoading = true;
      }
    },
    resetState: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.creatingPayment = false;
      state.customerPayment = undefined;
      state.receiptCreatedNum = "";
      state.paymentSuccessful = false;
      state.callingPaymentEndpoint = false;
      state.paymentFailed = false;
      state.paymentFailResponse = "";
      state.orderInfo = {};
      state.processingOrder = false;
      state.bspPayPayment = false;
      state.pdfReceiptStr = "";
      state.captchaValidated = false;
      state.lastError = null;
    },
    resetOrderInfo: (state, action) => {
      state.orderInfo = {};
      state.encryptingPayload = false;
      state.bspPayPayment = false;
      state.creatingPayment = false;
      state.callingPaymentEndpoint = false;
      state.customerPayment = undefined;
      state.paymentSuccessful = false;
      state.processingOrder = {};
      state.paymentFailed = false;
      state.paymentFailResponse = "";
    },
    captchaValidated: (state, action) => {
      state.validatingCaptcha = false;
      state.captchaValidated = action.payload.result;
    },
    // paymentCreated
    paymentCreated: (state, action) => {
      state.actionsLoading = false;
      state.lastError = null;
      state.creatingPayment = false;
      state.receiptCreatedNum = action.payload.receiptNum;
      state.paymentSuccessful = true;
      state.callingPaymentEndpoint = false;
      state.validatingCaptcha = false;
      state.captchaValidated = false;
    },
    paymentFailed: (state, action) => {
      const { comments } = action.payload;
      state.actionsLoading = false;
      state.lastError = null;
      state.creatingPayment = false;
      state.receiptCreatedNum = null;
      state.paymentSuccessful = false;
      state.callingPaymentEndpoint = false;
      state.paymentFailed = true;
      state.paymentFailResponse = comments;
    },
    generatedPDFReport: (state, action) => {
      state.actionsLoading = false;
      state.pdfReceiptStr = action.payload.reportStr;
    },
    orderProcessed: (state, action) => {
      state.orderInfo = action.payload.orderDetails;
      state.processingOrder = false;
    }
    /*,
    bspPayPayloadSent: (state, action) => {
      state.bspPayPayment = false;
    }
    */
  }
});

const unpersistedReducer = paymentSlice.reducer;
export const reducer = persistReducer(persistConfig, unpersistedReducer);
export const {actions} = paymentSlice;